import React, { useEffect, useState } from 'react';

import { formatMoney } from 'utils/money-utils';
import Form from 'react-bootstrap/Form';
import { InputFormEvent } from 'models/input-form-event';

interface Props {
    name: string;
    onChange?: (value: number, valid: boolean) => void;
    onBlur?: (event: InputFormEvent) => void;
    minValue?: number;
    allowZero?: boolean;
    initialData?: any;
    showErrors?: boolean;
}

const InputMoney = (props: Props) => {
    const [value, setValue] = useState<number>();
    const [formatted, setFormatted] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!isNaN(props.initialData)) {
            checkValidity(props.initialData);
        }
    }, [props.initialData]);

    const onChangeHandler = (e: any) => {
        checkValidity(e.target.value);
    };

    const checkValidity = (val: any) => {
        const numberValue = (typeof val != 'number') ? (parseInt((val + '').replace(/\D/g, '')) / 100) : val;

        const formattedVal = formatMoney(val) || '0,00';
        setFormatted("R$ " + formattedVal);

        const valid = !props.minValue || numberValue >= props.minValue;
        setError(!valid);
        setValue(numberValue);
        props.onChange && props.onChange(numberValue, valid);
    };

    const isInvalid = error || (props.showErrors && (value === null || value === undefined || (!props.allowZero && !value)));
    
    return (
        <>
            <Form.Control
                type="tel"
                name={props.name}
                isInvalid={isInvalid}
                value={formatted}
                onBlur={() => props.onBlur && props.onBlur({ name: props.name, value, valid: !isInvalid })}
                onChange={onChangeHandler}
            />
        </>
    );
};

export default InputMoney;